import React from "react";
import { Badge } from "@chakra-ui/react";

interface StatusBadgeProps {
  status: string;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const isActive = status === "Active";

  return (
    <Badge
      px={2}
      py={1}
      fontSize="xs"
      fontWeight="500"
      bg={isActive ? "rgba(56, 161, 105, 0.1)" : "rgba(229, 62, 62, 0.1)"}
      color={isActive ? "#276749" : "#C53030"}
      borderRadius="sm"
      textTransform="none"
    >
      {status}
    </Badge>
  );
} 